module.exports = __webpack_public_path__ + "img/login-logo-text.7b4e185a.png";